import { NgxCkeditorModule } from 'ngx-ckeditor4';
import { PrintService } from './services/print.service';
import { CsvdownloadService } from './services/csvdownload.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProgressBarModule } from 'angular-progress-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { MorrisJsModule } from 'angular-morris-js';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NestableModule } from 'ngx-nestable';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MarkdownModule } from 'ngx-markdown';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { LightboxModule } from 'ngx-lightbox';
import { LMarkdownEditorModule } from 'ngx-markdown-editor';
import { TreeviewMakerService } from './services/treeview-maker.service';
import { TreeModule } from '@circlon/angular-tree-component';
import { TreeviewModule } from 'ngx-treeview';
import { AdminModule } from './admin/admin.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './utils/services/auth.interceptor';
import { ngxLoadingAnimationTypes, NgxLoadingModule } from 'ngx-loading';
import { SlickCarouselModule } from 'ngx-slick-carousel';

@NgModule({
  declarations: [AppComponent],
  imports: [
    SlickCarouselModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    NgbModule,
    ProgressBarModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    MorrisJsModule,
    SweetAlert2Module.forRoot(),
    CKEditorModule,
    NestableModule,
    DragDropModule,
    MarkdownModule.forRoot(),
    CommonModule,
    NgbModule,
    NestableModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    LightboxModule,
    LMarkdownEditorModule,
    TreeviewModule.forRoot(),
    TreeModule,
    NgxCkeditorModule,
    AdminModule,
    HttpClientModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.threeBounce,
    }),
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true,
  },
    // { provide: LocationStrategy, useClass: HashLocationStrategy },
    CsvdownloadService, PrintService, TreeviewMakerService],
  bootstrap: [AppComponent],
})
export class AppModule { }
